import { Component, OnInit } from "@angular/core";
import { FormatStatusPipe } from "../QA-Page/helpers/formatStatus";
import {
  DataService,
  ModalService,
  NotificationService,
  TypedBaseListComponent,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { deleteQa, replyQa, updateQa } from "../graphql/Reply-QA";
import { GetOperator } from "../QA-Page/helpers/operator";
import { QAOrderReplyDialog } from "../qa-order-reply-dialog/qa-order-reply-dialog.component";
import { GetQuestionPostListDocument } from "src/generated-gql/graphql";
import { QuestionPostDialog } from "../QA-Page/components/question-post-dialog/question-post-dialog.component";
import { ChipComponent } from "../chip/chip.component";

@Component({
  standalone: true,
  selector: "qa-order-table",
  templateUrl: "./qa-order-table.component.html",
  imports: [SharedModule, FormatStatusPipe, ChipComponent],
})
export class QAOrderTableComponent
  extends TypedBaseListComponent<
    typeof GetQuestionPostListDocument,
    "questionPosts"
  >
  implements OnInit
{
  constructor(
    protected dataService: DataService,
    private modalService: ModalService,
    private notificationService: NotificationService
  ) {
    super();
    super.configure({
      document: GetQuestionPostListDocument,
      getItems: (data) => {
        return data.questionPosts;
      },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            title: {
              contains: this.searchTermControl.value,
            },
            type: {
              eq: "Order",
            },
            isDeleted: {
              eq: false,
            },
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addDateFilters()
    .addFilters([
      {
        name: "Secret",
        type: { kind: "boolean" },
        filterField: "secret",
        label: "Secret",
      },
      {
        name: "Status",
        type: {
          kind: "select",
          options: [
            { label: "Wait Response", value: "WaitResponse" },
            { label: "Answered", value: "Answered" },
          ],
        },
        filterField: "status",
        label: "Status",
      },
      {
        name: "Deleted",
        type: { kind: "boolean" },
        filterField: "isDeleted",
        label: "Deleted",
      },
      {
        name: "Human",
        type: { kind: "boolean" },
        filterField: "human",
        label: "Human",
      },
    ])
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSorts([{ name: "id" }, { name: "createdAt" }, { name: "userId" }]);


  colorMap = [
    { state: "WaitResponse", background: "var(--color-chip-warning-bg)", color: "var(--color-chip-warning-text)" },
    { state: "Open", background: "#5A9BDC", color: "white" },
    { state: "Resolved", background: "#61A75A", color: "white" },
    { state: "Answered", background: "#e10c0c", color: "white" },
  ];
  getChipBg(status: string) {
    return this.colorMap.find(m => m.state === status)!.background;
  }
  getChipColor(status: string) {
    return this.colorMap.find(m => m.state === status)!.color;
  }

  onReplyClick(data) {
    this.modalService
      .fromComponent(QuestionPostDialog, {
        locals: {
          questionId: data.id,
          refresh: this.refresh,
        },
        closable: true,
        size: "xl",
      })
      .subscribe((res) => {});
    // let actions;

    // this.modalService
    //   .fromComponent(QAOrderReplyDialog, {
    //     locals: {
    //       qa: data,
    //       refresh : () => {
    //         this.refresh()
    //       }
    //     },
    //     closable: true,
    //     size: "xl",
    //   })
    //   .subscribe((result) => {
    //     if (!result) return;
    //     console.log("F", result);
    //     actions = this.createFormData(data, result);
    //     const action = actions[result.case];
    //     if (!action) return;
    //     const mutationOptions =
    //       result.case === "delete_question"
    //         ? { id: action.id }
    //         : { input: action.input };

    //     console.log(action);
    //     console.log(mutationOptions);

    //     this.dataService
    //       .mutate(action.mutation, mutationOptions)
    //       .subscribe((e) => {
    //         console.log(e);

    //         this.notificationService.success(action.successMessage);
    //         this.refresh();
    //       });
    //   });
  }

  private createFormData(data: any, result: any) {
    return {
      create_reply: {
        mutation: replyQa,
        input: {
          postId: data.id,
          detail: result.reply,
        },
        successMessage: "Question Replied Successfully",
      },
      update_reply: {
        mutation: updateQa,
        input: {
          id: data.comments[0]?.id,
          detail: result.reply,
        },
        successMessage: "Reply Updated Successfully",
      },
      delete_question: {
        mutation: deleteQa,
        id: data.id,
        successMessage: "Question Deleted Successfully",
      },
    };
  }
  filterMode = "Product";
  onFilterModeChange() {
    switch (this.filterMode) {
      case "Product":
        this.filterMode = "Order";
        break;
      case "Order":
        this.filterMode = "Product";
        break;
    }
    this.refresh();
  }
}
